import styled from 'styled-components';
import { VisuallyHiddenMixin } from '../../mixins/components/VisuallyHiddenMixin';

/**
 * The visually hidden block is most likely to be used to support accessibility cases. For instance,
 * two visually conjoined inputs may need two separate labels for screen readers.
 * A simple `display: none` or `visibility: hidden` would result in the screen reader not picking
 * up the content of the element.
 *
 * @since 6.13.0
 */
var VisuallyHidden = /*#__PURE__*/styled.span.withConfig({
  displayName: "VisuallyHidden",
  componentId: "c11n-8-111-1__sc-t8tewe-0"
})(["", ""], VisuallyHiddenMixin);
VisuallyHidden.displayName = 'VisuallyHidden';

/** @component */
export { VisuallyHidden };